import {lazy} from 'react'

const LandingPage = lazy(async () => await import('pages/LandingPage'))
const RegisterPage = lazy(async () => await import('pages/RegisterPage'))
const LoginPage = lazy(async () => await import('pages/LoginPage'))
const LoginViaPhone = lazy(async () => await import('pages/LoginViaPhone'))
const ForgotPassword = lazy(async () => await import('pages/ForgotPassword'))
const ResetPassword = lazy(async () => await import('pages/ResetPassword'))
const Dashboard = lazy(async () => await import('pages/Dashboard'))
const CreateOrder = lazy(async () => await import('pages/CreateOrder'))
const Order = lazy(async () => await import('pages/Order'))
const PastOrders = lazy(async () => await import('pages/PastOrders'))
const Contacts = lazy(async () => await import('pages/Contacts'))
const Contact = lazy(async () => await import('pages/Contact'))
const Settings = lazy(async () => await import('pages/Settings'))
const Wallet = lazy(async () => await import('pages/Wallet'))
const NotFound = lazy(async () => await import('pages/NotFound'))

const routes = [
  {
    path: '/',
    name: 'LandingPage',
    exact: true,
    component: LandingPage,
    protected: false,
  },
  {
    path: '/register',
    name: 'Sign Up',
    exact: false,
    component: RegisterPage,
    protected: false,
  },
  {
    path: '/login',
    name: 'Login',
    exact: false,
    component: LoginPage,
    protected: false,
  },
  {
    path: '/login/phone',
    name: 'Login',
    exact: false,
    component: LoginViaPhone,
    protected: false,
  },
  {
    path: '/forgot-password',
    name: 'Forgot Password',
    exact: false,
    component: ForgotPassword,
    protected: false,
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    exact: false,
    component: ResetPassword,
    protected: false,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    exact: false,
    component: Dashboard,
    protected: true,
  },
  {
    path: '/dashboard/create-order',
    name: 'Schedule a Hauler',
    exact: false,
    component: CreateOrder,
    protected: true,
  },
  {
    path: '/order/:orderId',
    name: 'Order',
    exact: false,
    component: Order,
    protected: true,
  },
  {
    path: '/dashboard/settings',
    name: 'Settings',
    exact: false,
    component: Settings,
    protected: true,
  },
  {
    path: '/dashboard/wallet',
    name: 'Wallet',
    exact: false,
    component: Wallet,
    protected: true,
  },
  {
    path: '/dashboard/contacts',
    name: 'Contacts',
    exact: false,
    component: Contacts,
    protected: true,
  },
  {
    path: '/contact/:contactId',
    name: 'Contact',
    exact: false,
    component: Contact,
    protected: true,
  },
  {
    path: 'dashboard/order-history',
    name: 'Order History',
    exact: false,
    component: PastOrders,
    protected: true,
  },
  {
    path: '*',
    name: 'NotFound',
    exact: false,
    component: NotFound,
    protected: false,
  },
]

export default routes
